/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

const localeProps = new WeakMap();

export default class InternationalSupport {
  constructor(msgObject, localeStr) {
    const fallbackLanguage = 'en';
    if (msgObject
        && msgObject.translations) {
      let messages = msgObject.translations[fallbackLanguage];
      let locale = fallbackLanguage;
      if (typeof localeStr === 'string') {
        const tempLocalStr = localeStr.split && localeStr.split('-');
        if (tempLocalStr instanceof Array) {
          const langCode = tempLocalStr[0];
          if (msgObject.translations[localeStr]) {
            messages = msgObject.translations[localeStr];
            locale = localeStr;
          } else if (msgObject.translations[localeStr.toLowerCase()]) {
            messages = msgObject.translations[localeStr.toLowerCase()];
            locale = localeStr.toLowerCase();
          } else if (langCode && msgObject.translations[langCode.toLowerCase()]) {
            messages = msgObject.translations[langCode.toLowerCase()];
            locale = langCode.toLowerCase();
          }
        }
      }

      localeProps.set(this, {
        locale,
        messages
      });
    }
  }

  getLocale = () => localeProps.get(this).locale;

  getMessages = () => localeProps.get(this).messages;
}



// WEBPACK FOOTER //
// ./src/js/components/Localization/InternationalSupport.jsx